import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import productData from "../Data/productData.json";

const ProductDetail = () => {
  const { productId } = useParams();
  const product = productData[productId];

  const [litreInquiry, setLitreInquiry] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [contactNumber, setContactNumber] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleEnquiryClick = () => {
    setShowModal(true);
  };

  const handleConfirm = () => {
    // You can replace this with actual API call logic
    alert(
      `Enquiry submitted!\nContact: ${contactNumber}\nQuantity: ${litreInquiry} litres`,
    );
    setShowModal(false);
    setContactNumber("");
  };

  if (!product)
    return <h2 className="text-center pt-5 product-not">Product not found</h2>;

  return (
    <section className="container product-detail">
      <div className="card shadow-lg border-0">
        <div className="row g-0">
          <div className="col-md-5 bg-light">
            <div className="h-100 d-flex align-items-center justify-content-center p-3">
              <img
                src={product.image}
                alt={product.name}
                className="img-fluid rounded"
                style={{
                  maxHeight: "450px",
                  width: "100%",
                  objectFit: "contain",
                }}
              />
            </div>
          </div>

          <div className="col-md-7">
            <div className="card-body p-4">
              <h2 className="card-title mb-4">{product.name}</h2>

              <div className="table-responsive mb-4">
                <table className="table table-borderless">
                  <tbody>
                    <tr>
                      <th scope="row">Technical Name</th>
                      <td>{product.technicalName}</td>
                    </tr>
                    <tr>
                      <th scope="row">Business Type</th>
                      <td>{product.businessType}</td>
                    </tr>
                    <tr>
                      <th scope="row">Packaging Size</th>
                      <td>{product.packagingSize}</td>
                    </tr>
                    <tr>
                      <th scope="row">Brand Name</th>
                      <td>{product.brandName}</td>
                    </tr>
                    <tr>
                      <th scope="row">Location</th>
                      <td>{product.location}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="mb-4">
                <label htmlFor="litreInput" className="form-label fw-semibold">
                  How many quantity do you want?
                </label>
                <div className="d-flex flex-wrap align-items-center gap-2">
                  <input
                    type="number"
                    id="litreInput"
                    className="form-control"
                    placeholder="Enter Quantity"
                    value={litreInquiry}
                    onChange={(e) => setLitreInquiry(e.target.value)}
                    min="1"
                    style={{ maxWidth: "200px" }}
                  />
                  <b>litres</b>
                </div>
              </div>

              <div className="d-flex flex-column flex-md-row gap-3">
                <a href="/#product" className="btn btn-secondary">
                  ← Back
                </a>
                <button className="btn btn-outline-primary">
                  Request to Call
                </button>
                <button
                  className="btn btn-warning"
                  onClick={handleEnquiryClick}
                >
                  Send Enquiry
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Enquiry Modal */}
      {showModal && (
        <div
          className="modal-backdrop d-flex align-items-center justify-content-center"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1050,
          }}
        >
          <div
            className="modal-content"
            style={{
              background: "#fff",
              borderRadius: "10px",
              width: "90%",
              maxWidth: "500px",
              padding: "1.5rem",
              boxShadow: "0 0 20px rgba(0,0,0,0.2)",
            }}
          >
            <div className="modal-header d-flex justify-content-between align-items-center mb-3">
              <h5 className="modal-title m-0">Confirm Enquiry</h5>
              <button
                className="btn-close"
                type="button"
                onClick={() => setShowModal(false)}
              ></button>
            </div>

            <form
              action="https://formspree.io/f/xnndjkrz"
              method="POST"
              onSubmit={() => setTimeout(() => setShowModal(false), 1000)}
            >
              <div className="modal-body">
                <div className="mb-3">
                  <label htmlFor="contactInput" className="form-label">
                    Contact Number
                  </label>
                  <input
                    type="tel"
                    name="Contact Number"
                    className="form-control"
                    id="contactInput"
                    placeholder="Enter your contact number"
                    value={contactNumber}
                    onChange={(e) => setContactNumber(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="modalLitreInput" className="form-label">
                    Quantity (litres)
                  </label>
                  <input
                    type="number"
                    name="Quantity"
                    className="form-control"
                    id="modalLitreInput"
                    min="1"
                    value={litreInquiry}
                    onChange={(e) => setLitreInquiry(e.target.value)}
                    required
                  />
                </div>

                <input type="hidden" name="Product Name" value={product.name} />
              </div>

              <div className="modal-footer d-flex justify-content-end gap-2">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-success">
                  Confirm
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </section>
  );
};

export default ProductDetail;
